import notify from './notify'
import date from './date'
import host from './host'
import math from './math'
import state from './state'
import form from './form'
import EventSystem from './EventSystem'
import assets from './assets'
import logger from './logger'
import translate from './translate'
import string from './string'

var helpers = {}
try {
  // eslint-disable-next-line
  helpers = require('../projects/' + process.env.REACT_APP_PROJECT + '/helpers')
} catch (e) {
  logger.debug('No project-specific helpers')
}
module.exports = {
  notify,
  date,
  host,
  math,
  logger,
  string,
  Translate: translate,
  AssetsHelper: assets,
  StateHelper: state,
  FormHelper: form,
  EventSystem: EventSystem,
  ...helpers
}



// WEBPACK FOOTER //
// ./src/helpers/index.js